import { ApiEndpointClient } from './resource-client';
const BACKEND_FOR_FRONTEND_PREFIX = 'valuation-frontend';
export class AssetOverviewsClient extends ApiEndpointClient {
    constructor(http) {
        super(http, BACKEND_FOR_FRONTEND_PREFIX);
    }
    getMapAssets = async () => {
        return this.get('/map-assets/');
    };
    getAssetsWithOrders = async ({ searchString, customerId } = {}, options) => {
        return this.get('/asset-orders/', {
            signal: options?.signal,
            query: {
                ...(searchString ? { search_string: searchString } : {}),
                ...(customerId ? { customer_uuid: customerId } : {}),
            },
        });
    };
}
